import React from 'react';
import { Field } from 'react-final-form';

import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptchaField = React.forwardRef( ( { field }, ref ) => (
  <Field
    name={field}
    validate={( checked ) => ( checked ? null : 'This field is required' )}
  >
    {( { input, meta } ) => (
      <div>
        <ReCAPTCHA
          ref={ref}
          sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
          onChange={( value ) => {
            input.onChange( !!value );
          }}
        />
        {meta.touched && !input.value && (
          <div className="invalid-feedback d-block">This field is required</div>
        )}
      </div>
    )}
  </Field>
) );

export default ReCaptchaField;
